<template>
    <v-container>
        <v-row align="center" class="text-center justify-align-center">
            <v-col cols="12" class="mb-n5">
                <img v-if="$store.getters.vendor.logo" class="logo" height="180px" src="@/assets/logo-new.png">
            </v-col>
            <v-col cols="12" class="px-10">
                <p class="black--text mb-1" :class="isMobile ? 'text-h5 font-weight-medium' : 'text-h4 font-weight-bold'">Oops!! This site is currently Out of Service</p>
                <label class="grey--text" :class="isMobile ? 'text-body-1' : 'text-h6'">We apologize for the incovenience caused</label>
            </v-col>
            <v-col cols="12" class="mt-n16">
                <v-img class="text-center" src="@/assets/maintenance.png" :height="!isMobile? '600px' : ''" contain/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped></style>